module.exports = __webpack_public_path__ + "static/media/sophisticated.ed22b1d7.png";